import React, {ReactElement, useState} from 'react';
import {useIntl, FormattedMessage} from 'react-intl';
import {cx} from '@emotion/css';

import BaseModal from '@fo/designSystem/BaseModal/BaseModal';
import {fonts} from '@fo/shared/styles/variables';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';
import Headers, {HeaderType} from '@fo/designSystem/Text/Headers/Headers';
import MarketingSignupEmailCaptureForm from '@fo/components/MarketingSignupEmailCaptureForm';
import DynamicLink from '@fo/components/DynamicLink/DynamicLink';
import {useSetModalContent} from '@fo/shared-providers/ModalContextProvider';
import {segmentEvents, track} from '@fo/shared-analytics/tracking/segment';

import styles from './SignupModal.styles';

function SignupModal(): ReactElement {
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
  const {formatMessage} = useIntl();
  const setModalContent = useSetModalContent();

  const handleOnSubmit = (isSubmitted: boolean) => {
    track(segmentEvents.actions.modalMailingListSignupSubmit, {
      url: window?.location.href,
    });
    setIsFormSubmitted(isSubmitted);
  };

  return (
    <BaseModal>
      <div className={cx(styles.signupModal)} data-testid="modal.signupForm">
        {!isFormSubmitted ? (
          <>
            <Headers headerType={HeaderType.H2} alignment={fonts.alignment.CENTER}>
              <FormattedMessage id="signup.modal.title" />
            </Headers>
            <Paragraph alignment={fonts.alignment.CENTER} fontWeight={fonts.weight.REGULAR}>
              <FormattedMessage
                id="signup.modal.subtitle.v2"
                values={{
                  'a-terms': (...chunks: string[]) => (
                    <DynamicLink
                      href={formatMessage({id: 'signup.modal.subtitle.v2.termsUrl'})}
                      onClick={() => setModalContent(undefined)}
                      blank
                    >
                      {chunks}
                    </DynamicLink>
                  ),
                }}
              />
            </Paragraph>
            <MarketingSignupEmailCaptureForm onSubmit={handleOnSubmit} />
          </>
        ) : (
          <Headers headerType={HeaderType.H2} alignment={fonts.alignment.CENTER}>
            <FormattedMessage id="signup.modal.thankYou" />
          </Headers>
        )}
      </div>
    </BaseModal>
  );
}

export default SignupModal;
